import requestModule from '@/assets/libs/requestModule'
import Util from '@/assets/libs/util'
import CartController from '@/assets/controllers/CartController'

const getProductsCart = function () {
    let cart = CartController.getCart()
    let products = []
    cart.forEach((item, index) => {
        products.push({
            index: index,
            quantity: item.quantity || 1,
            productName: item.productName,
            productCode: item.productCode,
            productPrint: item.productPrint,
            discount: item.hasOwnProperty('discountBkpSubgroupDiscounts') ? item.discountBkpSubgroupDiscounts : item.discount || 0,
            unitValue: item.hasOwnProperty('priceBkpSubgroupDiscounts') ? item.priceBkpSubgroupDiscounts : item.price,
            observations: getObservations(item.observations || []),
            toTravel: item.toTravel || false,
            childItems: getComboProducts(item.productCombo || [])
        })
    })
    return products
}

const getComboProducts = function (combo) {
    let products = []
    if (!combo || combo.length === 0) return products
    combo.forEach((item, index) => {
        products.push({
            index: index,
            quantity: (item.quantity || 1),
            discount: item.hasOwnProperty('discountBkpSubgroupDiscounts') ? item.discountBkpSubgroupDiscounts : (item.discount || 0),
            productCode: item.productCode || item.subItemCode,
            productName: item.productName || item.subItemName,
            productPrint: item.productPrint || item.subItemProductPrint,
            groupPrint: item.groupPrint || item.subItemGroupPrint,
            unitValue: item.hasOwnProperty('priceBkpSubgroupDiscounts') ? item.priceBkpSubgroupDiscounts : item.price,
            observations: getObservations(item.observations || []),
            childItems: getComboDoCombo((item.choosen || {}))
        })
    })
    return products
}

const getComboDoCombo = function (combo) {
    let products = []
    // Desabilitado pois no fos não considera os itens do combo do combo para o desconto enviando um payload menor
    /* if (combo) {
        Object.keys(combo).forEach((key, indexC) => {
            combo[key].forEach((cc, indexCC) => {
                let item = {
                    index: indexC + indexCC,
                    productCode: cc.subItemCode,
                    productName: cc.subItemName,
                    productPrint: cc.subItemProductPrint,
                    groupPrint: cc.groupPrint || cc.subItemGroupPrint,
                    quantity: (cc.quantity || 1),
                    unitValue: cc.hasOwnProperty('priceBkpSubgroupDiscounts') ? cc.priceBkpSubgroupDiscounts : cc.price,
                    discount: cc.hasOwnProperty('discountBkpSubgroupDiscounts') ? cc.discountBkpSubgroupDiscounts : cc.discount || 0,
                    observations: getObservations(cc.observations || [])
                }
                products.push(item)
            })
        })
    } */
    return products
}

const getObservations = function (observations) {
    let obsList = []
    // Desabilitado pois no fos não considera as observações para o desconto
    /* if (observations && observations.length > 0) {
        observations.forEach(obs => {
            obsList.push({
                obsGroupCode: obs.obsGroupCode || obs.subItemObsGroupCode,
                obsCode: obs.obsCode || obs.subItemObsCode,
                obsProductCode: obs.obsProductCode || obs.subItemObsProductCode,
                obsName: obs.obsName || obs.subItemObsName,
                obsType: obs.obsType || obs.subItemObsType,
                price: obs.hasOwnProperty('priceBkpSubgroupDiscounts') ? obs.priceBkpSubgroupDiscounts : obs.price,
                quantity: obs.quantity || 1,
                discount: obs.discount || 0
            })
        })
    } */
    return obsList
}

const applyDiscountsOnCart = function (cartWithDiscounts, removeDiscounts = false) {
    try {
        let cart = CartController.getCart()
        let totalDiscountSubgroupItem = 0
        cart.forEach((item, index) => {
            if (removeDiscounts) {
                totalDiscountSubgroupItem += removeDiscountsItem(item)
            } else {
                const itemWithDiscount = cartWithDiscounts[index]
                totalDiscountSubgroupItem += applyDiscountsItem(item, itemWithDiscount)
            }

            if (item.productCombo && item.productCombo.length > 0) {
                item.productCombo.forEach((combo, indexCombo) => {
                    const comboItemWithDiscount = cartWithDiscounts[index] && cartWithDiscounts[index].childItems && cartWithDiscounts[index].childItems[indexCombo]
                    if (!comboItemWithDiscount) return
                    if (removeDiscounts) {
                        totalDiscountSubgroupItem += removeDiscountsItem(combo)
                    } else {
                        totalDiscountSubgroupItem += applyDiscountsItem(combo, comboItemWithDiscount)
                    }
                    if (combo.choosen && Object.keys(combo.choosen).length > 0) {
                        Object.keys(combo.choosen).forEach((key, indexKey) => {
                            combo.choosen[key].forEach((choosen, indexChoosen) => {
                                const choosenWithDiscount = comboItemWithDiscount.childItems[indexChoosen]
                                if (!choosenWithDiscount) return
                                if (removeDiscounts) {
                                    totalDiscountSubgroupItem += removeDiscountsItem(choosen)
                                } else {
                                    totalDiscountSubgroupItem += applyDiscountsItem(choosen, choosenWithDiscount)
                                }
                            })
                        })
                    }
                })
            }
            item.totalDiscountSubgroupItem = totalDiscountSubgroupItem
            totalDiscountSubgroupItem = 0
        })
        CartController.recalculateCart()
    } catch (error) {
        console.log(error)
        throw new Error('Erro ao aplicar descontos. <br>' + error.message)
    }
}

const applyDiscountsItem = function (item, itemWithDiscount) {
    let totalDiscountSubgroupItem = 0
    let discountToApply = parseFloat(itemWithDiscount.discount || 0)
    if (!item.hasOwnProperty('priceBkpSubgroupDiscounts')) {
        // priceBkpSubgroupDiscounts utilizado para manter o preço original do item antes do desconto do grupo para não aplicar o desconto de forma cumulativa do grupo novamente no item
        item.priceBkpSubgroupDiscounts = Util.deepCopy(item.price)
        item.discountBkpSubgroupDiscounts = Util.deepCopy(item.discount || 0)
    }
    if (item.discountBkpSubgroupDiscounts !== discountToApply) {
        item.discount = discountToApply
        item.price = item.priceBkpSubgroupDiscounts - (item.discount || 0)
    }
    totalDiscountSubgroupItem = (discountToApply - item.discountBkpSubgroupDiscounts)
    return totalDiscountSubgroupItem
}

const removeDiscountsItem = function (item) {
    item.discount = item.hasOwnProperty('discountBkpSubgroupDiscounts') ? item.discountBkpSubgroupDiscounts : (item.discount || 0)
    item.price = item.hasOwnProperty('priceBkpSubgroupDiscounts') ? item.priceBkpSubgroupDiscounts : item.price
    return 0
}

export default {
    applyRemoveDiscounts: async function (currentCart, removeDiscounts = false) {
        if (Util.isTapMode()) return

        if (!currentCart || currentCart.length === 0) return

        try {
            const generalInfo = Util.getGeneralInfo() || {}
            const requestParams = {
                subsidiaryCode: generalInfo['subsidiaryCode'],
                storeCode: generalInfo['storeCode'],
                posCode: String(generalInfo['posCode'] || ''),
                cart: getProductsCart()
            }
            applyDiscountsOnCart(currentCart, true)
            if (removeDiscounts) {
                return
            }
            const res = await requestModule.postRequest('menu/getSubgroupDiscounts', requestParams)

            if (!res || res.error) {
                throw new Error('Não foi possivel verificar os descontos. <br>' + (res && res.message) || '')
            }

            const apiCart = (res.data && res.data.cart) || []

            if (Array.isArray(apiCart) && apiCart.length > 0) {
                applyDiscountsOnCart(apiCart, removeDiscounts)
            }
        } catch (error) {
            Util.showInfoModal(error.message, false)
            throw error
        }
    }
}



// WEBPACK FOOTER //
// ./src/assets/controllers/SubgroupDiscountController.js